<template>
  <div>
    <ValidationProvider
      mode="aggressive"
      rules="required|min:8"
      v-slot="{ errors, dirty }"
      ref="passwordInputRef"
      :name="$t('passwordInput.name')"
    >
      <v-text-field
        :value="value"
        @click:append="showPassword = !showPassword"
        @input="updateValue"
        data-e2e="passwordInput"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :error-messages="errors"
        :type="showPassword ? 'text' : 'password'"
      >
        <template v-slot:label>
          <span class="PasswordInput-label">{{ $t('passwordInput.label') }}</span>
        </template>
      </v-text-field>
      <div
        class="PasswordInput-error mt-3"
        :class="{ 'red--text': errors.min }"
        data-e2e="passwordInputErrorMessageMinChar"
      >
        <v-icon left small :color="getColor(errors.min, dirty)">mdi-check-circle</v-icon
        >{{ $t('passwordInput.passwordError.min', { value: 8 }) }}
      </div>
      <div
        class="PasswordInput-error"
        :class="{ 'red--text': getColor(notSpecialChar, dirty) === 'error' }"
        data-e2e="passwordInputErrorMessageSpecialChar"
      >
        <v-icon left small :color="getColor(notSpecialChar, dirty)">mdi-check-circle</v-icon
        >{{ $t('passwordInput.passwordError.specialCharacter', { value: 1 }) }}
      </div>
      <div
        class="PasswordInput-error"
        :class="{ 'red--text': getColor(notNumber, dirty) === 'error' }"
        data-e2e="passwordInputErrorMessageNotNumber"
      >
        <v-icon left small :color="getColor(notNumber, dirty)">mdi-check-circle</v-icon
        >{{ $t('passwordInput.passwordError.number', { value: 1 }) }}
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'PasswordInput',
  components: { ValidationProvider },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPassword: false
    }
  },
  computed: {
    notNumber() {
      const format = /[0-9]/
      return !format.test(this.value)
    },
    notSpecialChar() {
      const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
      return !format.test(this.value)
    },
    submitable() {
      return !this.notNumber && !this.notSpecialChar && this.value.length >= 8
    }
  },
  methods: {
    getColor(failed, dirty) {
      if (!dirty) return ''
      return failed ? 'error' : 'success'
    },
    updateValue(valuePwd) {
      this.$nextTick(() => {
        valuePwd === '' && this.$refs.passwordInputRef.reset()
        this.$emit('submitable', this.submitable)
      })
      this.$emit('input', valuePwd)
    }
  }
}
</script>

<style scoped lang="scss">
.PasswordInput-label {
  font-weight: 700;
  color: var(--v-secondary-base);
}

.PasswordInput-error {
  text-align: left;
}
</style>
